module.exports = __webpack_public_path__ + "6c191b15ec2fc0d6ac0f6517d8a854b5.svg";